import gql from 'graphql-tag';
import { PromotionBasicFields } from './fragments/Promotion';

const key = `GetPeriodPromotions`;
const query = gql`
${PromotionBasicFields}
  query ${key} (
    $periodId: ID!
    $promotionList: Int = 100
    $storeId: ID = "invalid"
    $storeType: StoreType = null
  ) {
    STORE_PROMOTION: getPeriod(id: $periodId) {
      id
      promotions(
        limit: $promotionList
        filter: {
          and: [{ type: { eq: STORE_PROMOTION } }, { promotionStoreId: { eq: $storeId } }]
        }
        sortDirection: DESC
      ) {
        items {
          ...PromotionBasicFields
        }
      }
    }
    HOT_OFFER_BY_STORE_TYPE: getPeriod(id: $periodId) {
      id
      promotions(
        limit: $promotionList
        filter: { and: [{ type: { eq: HOT_OFFER } }, { storeType: { eq: $storeType } }] }
        sortDirection: DESC
      ) {
        items {
          ...PromotionBasicFields
        }
      }
    }
    HOT_OFFER: getPeriod(id: $periodId) {
      id
      promotions(
        limit: $promotionList
        filter: { type: { eq: HOT_OFFER } } 
        sortDirection: DESC
      ) {
        items {
          ...PromotionBasicFields
        }
      }
    }
    MAJOR_PROMOTION: getPeriod(id: $periodId) {
      id
      promotions(
        limit: $promotionList
        filter: { type: { eq: MAJOR_PROMOTION } }
        sortDirection: DESC
      ) {
        items {
          ...PromotionBasicFields
        }
      }
    }
  }
`;

export const GET_PERIOD_PROMOTIONS = { key, query };
